var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-more"},_vm._l((_vm.stories),function(story,index){return _c('app-story',{key:index,attrs:{"image":story.image,"size":story.size,"type":story.type,"link":story.link}},[_c('h2',{attrs:{"slot":"title"},domProps:{"innerHTML":_vm._s(story.title)},slot:"title"}),_vm._v(" "),_c('p',{attrs:{"slot":"text"},domProps:{"innerHTML":_vm._s(story.text)},slot:"text"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bbec6a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleMore.vue
// module id = Ombx
// module chunks = 0